import React from 'react'
import { PMPBodySectionItems } from './styledComponent'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import SignatureComponent from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/body/SignatureComponent'
import { EMR_SECTION_IDS } from 'src/mentor/components/MentorPrescriptionTemplates/components/utils/emrSectionIds'

/**
 * Resolves signature image ID from EMR signature section or prescription/template data.
 * Prefers signatureDetails.imageId (new payload), then legacy signature.
 */
function getSignatureImageId(emrSections, prescriptionData) {
  const section = emrSections?.find((s) => s?.id === EMR_SECTION_IDS.SIGNATURE)
  const fromSection =
    section?.signatureImageId ?? section?.properties?.signatureImageId ?? section?.signature
  if (fromSection) return fromSection
  return prescriptionData?.signatureDetails?.imageId ?? prescriptionData?.signature ?? null
}

/**
 * Resolves doctor name from EMR signature section or prescription/template data.
 */
function getSignatureDoctorName(emrSections, prescriptionData) {
  const section = emrSections?.find((s) => s?.id === EMR_SECTION_IDS.SIGNATURE)
  const fromSection =
    section?.doctorName ?? section?.properties?.doctorName
  if (fromSection) return fromSection
  return prescriptionData?.doctorName ?? ''
}

export default function PrintableSignatureColumn({
  prescriptionData,
  emrSections,
  signatureRef,
  styleOverrides,
  debug,
  debugHighlightStates,
}) {
  const signatureImageId = getSignatureImageId(emrSections, prescriptionData)
  const doctorName = getSignatureDoctorName(emrSections, prescriptionData)
  const signatureDetails = prescriptionData?.signatureDetails || {}
  const position = signatureDetails.signaturePosition === 'left' ? 'start' : 'end'

  if (!signatureImageId) return null

  return (
    <PMPBodySectionItems
      ref={signatureRef}
      debug={debug}
      debugColor={PRESCRIPTION_COLORS_MAP.nextVisitAndSignature?.color ?? '#1e293b'}
      debugHighlight={debugHighlightStates?.signature}
    >
      <div className={`d-flex align-items-center justify-content-${position}`}>
        <SignatureComponent
          signatureSize={styleOverrides?.otherStyles?.signatureSize}
          signatureMediaId={signatureImageId}
          doctorName={doctorName}
          richText={signatureDetails.richText}
          showPractitionerName={signatureDetails.showPractitionerName}
          practitionerNameCase={signatureDetails.practitionerNameCase}
        />
      </div>
    </PMPBodySectionItems>
  )
}
